module.exports = __webpack_public_path__ + "static/media/Sol-branco.de783ef1.svg";